import React from 'react';
import users from '../users';
import Header from './Header';
import movies from '../movies';
import MovieCard from './MovieCard';

const Perfil = () => {
    const [current, setCurrent] = React.useState('assistidos');
    const [preferidos] = React.useState(() => {
        const localList = localStorage.getItem('preferidos')
        return localList ? JSON.parse(localList) : []
    });
    React.useEffect(()=>{
        window.localStorage.setItem('preferidos', JSON.stringify(preferidos))
    },[preferidos])
    const currentUser = users[0];
    return (
        <>
            <Header isTransparent={true} />
            <div className="userPerfil">
                <div className="userPerfil__hero">
                    <img src={currentUser.userImg} alt={currentUser.nome} />
                    <div className="userPerfil__hero__wrapper">
                        <div>
                            <h1>{currentUser.nome}</h1>
                            <div className="userStats">
                                <div className="userStats__stat">
                                    <p className="userStats__number">{preferidos.length/2}</p>
                                    <p>Preferidos</p>
                                </div>  
                                <div className="pipeline">|</div>
                                <div className="userStats__stat">
                                    <p className="userStats__number">{currentUser.seguidores}</p>
                                    <p>Seguidores</p>
                                </div> 
                            </div> {/* <!--/USERSTATS-->*/}
                        </div>
                    </div> {/* <!--/WRAPPER-->*/}
                </div> {/* <!--/HERO--> */}
                <div className="userPerfil__tabs">
                    <div className={`userPerfil__tabs__assistidos ${current==='assistidos'? 'userPerfil__tabs__ativo' : '' }`} onClick={()=>{
                        setCurrent('assistidos');
                    }
                    }>Já assistidos</div>
                    <div className={`userPerfil__tabs__quero ${current==='quero'? 'userPerfil__tabs__ativo' : '' }`} onClick={()=>{
                        setCurrent('quero')
                    }}>Quero assistir</div>
                </div>
                <div className={`userPerfil__assistidos usePerfil__filmes ${current==='assistidos'? 'show--flex':''}`}>
                    {preferidos.map((preferido, index)=>{
                        if((index%2)===0){
                            return (
                                <MovieCard key={preferido.id} movie={movies.find(movie=>movie.id===preferido.id)} stars={false} />
                            )
                        }else{
                            return null
                        }
                    })}
                </div>
                <div className={`userPerfil__quero userPerfil__filmes ${current==='assistidos'? 'show--flex':''}`}>

                </div>
            </div>
        </>
    )
}

export default Perfil
